const UPDATE_AUTHENTIFICATION = 'UPDATE_AUTHENTIFICATION';
export default UPDATE_AUTHENTIFICATION;



// WEBPACK FOOTER //
// ./src/store/drivers/types.js